<template>
  <nav :class="{active}" id="sidebar">
    <template v-if="isLogged">

      <div class="icono">
        <a><img src="/img/icons/icono_blanco.png" alt="IBERBOX"></a>
      </div>

      <div v-if="hasCloudFeature && hasPaymentMethod" class="border-none" @mouseenter="mouseEnterCloud" @mouseleave="mouseLeaveCloud" style="position: relative">
        <div id="files" :class="[isCloudRoute || isCloud ? 'action-activo' : 'action']">
          <router-link to="/files" :aria-label="$t('sidebar.myCloud')" :title="$t('sidebar.myCloud')" tag="button">
            <cloud-icon size="1.5x" class="custom-class"></cloud-icon>
            <span>{{ $t('sidebar.myCloud') }}</span>
          </router-link>
        <img v-if="revealSecrets" :class="[isRotate ? 'arrow-rotate' : 'arrow']" src="/img/icons/Reg/arrow-icon.svg" @click="show"> <!-- Se muestra solo si hay espacios abiertos -->
        </div>
        <div v-if="revealSecrets && isRotate" class="espacios-privados">
          <private-space v-for="(space) in openSecrets"
            :key="space.handle"
            v-bind:handle="space.handle"
            v-bind:name="space.name">
          </private-space>
        </div>
      </div>

      <div v-if="hasPaymentMethod" class="border-none" @mouseenter="mouseEnterSharedDrive" @mouseleave="mouseLeaveSharedDrive">
        <router-link :class="[isSharedDriveRoute ? 'action-activo' : 'action']" to="/shared-drive" :aria-label="$t('sidebar.sharedDrives')" :title="$t('sidebar.sharedDrives')" tag="button">
          <share-2-icon size="1.5x" class="custom-class"></share-2-icon>
          <span>{{ $t('sidebar.sharedDrives') }}</span>
        </router-link>
      </div>
      
      <div v-if="hasBackupFeature && hasPaymentMethod" class="border-none" @mouseenter="mouseEnterBackup" @mouseleave="mouseLeaveBackup">
        <router-link :class="[isBackup || isBakRoute ? 'action-activo' : 'action']" to="/bak" :aria-label="$t('sidebar.backups')" :title="$t('sidebar.backups')" tag="button">
          <LayersIcon size="1.5x" class="custom-class"></LayersIcon>
          <span>{{ $t('sidebar.backups') }}</span>
        </router-link>
      </div>

      <!-- <div v-if="hasBmailFeature && hasPaymentMethod" class="border-none" @mouseenter="mouseEnterInbox" @mouseleave="mouseLeaveInbox">
        <a :class="comprobarInbox" href="https://bmail.iberbox.com/login" target="_blank" :aria-label="$t('sidebar.register')" :title="$t('sidebar.register')" tag="button">
          <inbox-icon size="1.5x" class="custom-class"></inbox-icon>
          <span>{{ $t('sidebar.register') }}</span>
        </a>
      </div> -->

      <div v-if="hasPaymentMethod" class="border-none" @mouseenter="mouseEnterTransfer" @mouseleave="mouseLeaveTransfer">
        <router-link :class="comprobarTransfer" to="/transfers" :aria-label="$t('sidebar.transfers')" :title="$t('sidebar.transfers')" tag="button">
          <repeat-icon size="1.5x" class="custom-class"></repeat-icon>
          <span>{{ $t('sidebar.transfers') }}</span>
        </router-link>
      </div>

      <div v-if="isReseller === 1 && hasPaymentMethod" class="border-none" @mouseenter="mouseEnterDealers" @mouseleave="mouseLeaveDealers">
        <router-link :class="comprobarResellers" to="/dealers" :aria-label="$t('sidebar.dealers')" :title="$t('sidebar.dealers')" tag="button">
          <gift-icon size="1.5x" class="custom-class"></gift-icon>
          <span>{{ $t('sidebar.dealers') }}</span>
        </router-link>
      </div>

      <div v-if="hasPaymentMethod" class="border-none" @mouseenter="mouseEnterConfig" @mouseleave="mouseLeaveConfig">
        <router-link :class="[(isConfig || isConfigRoute) ? 'action-activo' : 'action']" to="/profile" :aria-label="$t('sidebar.profile')" :title="$t('sidebar.profile')" tag="button">
          <user-icon size="1.5x" class="custom-class"></user-icon>
          <span>{{ $t('sidebar.profile') }}</span>
        </router-link>
      </div>

      <button v-if="!noAuth" @click="logout" :class="[isLogout ? 'action-activo' : 'action']" id="logout" :aria-label="$t('sidebar.logout')" :title="$t('sidebar.logout')" @mouseenter="mouseEnterLogout" @mouseleave="mouseLeaveLogout">
        <log-out-icon size="1.5x" class="custom-class"></log-out-icon>
        <span>{{ $t('sidebar.logout') }}</span>
      </button>

      <div class="space">
        <p class="used-space">{{ $t('sidebar.usedSpace') }}</p>
        <span>{{ spaceAvailableString }} ({{ accountUsage  }})</span>
        <div class="spacebar">
          <div class="spacebar-value" :style="spaceBarStyles"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="icono">
        <a><img src="/img/icons/icono_blanco.png" alt="IBERBOX"></a>
      </div>

      <div class="border-none" @mouseenter="mouseEnterLogin" @mouseleave="mouseLeaveLogin">
        <router-link :class="[isLogin ? 'action-activo' : 'action']" to="/login" :aria-label="$t('sidebar.login')" :title="$t('sidebar.login')" tag="button">
          <log-in-icon size="1.5x" class="custom-class"></log-in-icon>
          <span>{{ $t('sidebar.login') }}</span>
        </router-link>
      </div> 
      
      <div class="border-none" @mouseenter="mouseEnterSignup" @mouseleave="mouseLeaveSignup">
        <router-link v-if="signup" :class="[isSignup ? 'action-activo' : 'action']" to="/register" :aria-label="$t('sidebar.signup')" :title="$t('sidebar.signup')" tag="button">
          <user-plus-icon size="1.5x" class="custom-class"></user-plus-icon>
          <span>{{ $t('sidebar.signup') }}</span>
        </router-link>
      </div>
    </template>
  </nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
// import * as auth from '@/utils/auth';
import { version, signup, disableExternal, noAuth } from '@/utils/constants';
import { files as ibbapi } from '@/api';
import PrivateSpace from './PrivateSpace.vue';
import { CloudIcon, RepeatIcon, GiftIcon, UserIcon, LogOutIcon, Share2Icon, LogInIcon, UserPlusIcon, LayersIcon } from 'vue-feather-icons';
import filesize from 'filesize';
import { ROUTES } from '../router';
import CheckPassword from './prompts/CheckPassword.vue';

export default {
  name: 'sidebar',
  components: {
    PrivateSpace,
    CloudIcon,
    RepeatIcon,
    GiftIcon,
    UserIcon,
    LogOutIcon,
    Share2Icon,
    LogInIcon,
    UserPlusIcon,
    LayersIcon
},
  data: function () {
    return {
      isBackup: false,
      isInbox: false,
      isCloud: false,
      isTransfer: false,
      isDealers: false,
      isConfig: false,
      isLogout: false,
      isLogin: false,
      isSignup: false,
      isSharedDrive: false,
      isBackupClick: false,
      isInboxClick: false,
      isCloudClick: false,
      isTransferClick: false,
      isDealersClick: false,
      isConfigClick: false,
      isLogoutClick: false,
      isSharedDriveClick: false,
      isReseller: 0,
      isRotate: false,
      openSecrets: [],
      availableSpace: '0%',
    };
  },
  watch: {
    '$route': 'fetchData'
  },
  created () {
    if (this.$route.name === ROUTES.DRIVE) {
      const thisComponent = this;
      const JavaEventListenerClass = Module.ActionListener.extend('ActionListener', {
        onActionFinish: async function(action)
        {
          if (action.type == Module.ActionType.MANAGE_SECRETS.value && (action.intValue == 4 || action.intValue == 3 || action.intValue == 8 || action.intValue == 5 || action.intValue == 2)) {
            thisComponent.getOpenSecrets();
          }

          if (action.type === Module.ActionType.UPLOAD.value || action.type === Module.ActionType.DELETE_NODE.value) {
            await thisComponent.updateAccountInfo();
          }
        } 
      });

      this.interfaceObject = new JavaEventListenerClass();
      ibbLink.addActionListener(this.interfaceObject);
    } else {
      const thisComponent = this;
      const JavaEventListenerClass = Module.ActionListener.extend('ActionListener', {
        onActionFinish: async function(action)
        {
          if (action.type == Module.ActionType.MANAGE_SECRETS.value && (action.intValue == 4 || action.intValue == 3 || action.intValue == 8 || action.intValue == 5 || action.intValue == 2)) {
            thisComponent.getOpenSecrets();
          }

          if (action.type === Module.ActionType.UPLOAD.value || action.type === Module.ActionType.DELETE_NODE.value) {
            await thisComponent.updateAccountInfo();
          }
        } 
      });

      this.interfaceObject = new JavaEventListenerClass();
      ibb.addActionListener(this.interfaceObject);
    }
  },
  beforeDestroy () {
    if (this.$route.name === ROUTES.DRIVE) {
      ibbLink.removeActionListener(this.interfaceObject);
    } else {
      ibb.removeActionListener(this.interfaceObject);
    }
    window.removeEventListener('click', this.mouseClick);
  },
  computed: {
    ...mapState([ 'user', 'accountInfo', 'invoicingInfo' ]),
    ...mapGetters([ 'isLogged', 'accountUsage', 'hasPaymentMethod', 'hasCloudFeature', 'hasBackupFeature', 'hasBmailFeature', 'hasSecretsFeature' ]),
    active () {
      return this.$store.state.show === 'sidebar';
    },
    signup: () => signup,
    version: () => version,
    disableExternal: () => disableExternal,
    noAuth: () => noAuth,
    revealSecrets() {
      return this.hasSecretsFeature && (this.$route.name === ROUTES.CLOUD || this.$route.name === ROUTES.SECRET) && this.openSecrets.length > 0;
    },
    comprobarInbox() {
      if (!(this.accountInfo.features & Module.FeatureType.FEATURE_BMAIL.value)) {
        return 'action-disabled';
      } else if (this.isInbox) {
        return 'action-activo';
      } else {
        return 'action';
      }
    },
    isBakRoute() {
      return this.$route.name === ROUTES.BACKUP;
    },
    isCloudRoute() {
      return this.$route.name === ROUTES.CLOUD || this.$route.name === ROUTES.BIN || this.$route.name === ROUTES.SECRET;
    },
    isConfigRoute() {
      return this.$route.name === ROUTES.SETTINGS || this.$route.name === ROUTES.INVOICING || this.$route.name === 'Invoicing Plans' || this.$route.name === ROUTES.INFO || this.$route.name === ROUTES.ACCOUNT;
    },
    comprobarTransfer() {
      if (!this.hasPaymentMethod) {
        return 'action-disabled';
      } else if (this.isTransfer || this.$route.name === ROUTES.DOWNLOADS || this.$route.name === ROUTES.UPLOADS) {
        return 'action-activo';
      } else {
        return 'action';
      }
    },
    isSharedDriveRoute() {
      return this.isSharedDrive || this.$route.name === ROUTES.MY_SHARED_DRIVES || this.$route.name === ROUTES.SHARED_WITH_ME || this.$route.name === ROUTES.DRIVE || this.$route.name === ROUTES.ARCHIVED;
    },
    comprobarResellers() {
      if (!this.hasPaymentMethod) {
        return 'action-disabled';
      } else if (this.isDealers || this.$route.name === 'Referrals' || this.$route.name === 'Resellers') {
        return 'action-activo';
      } else {
        return 'action';
      }
    },
    spaceAvailableString () {
      if (!this.accountInfo.tstorage) {
        return this.$t('info.loading');
      }

      if (this.accountInfo.tstorage > this.accountInfo.ustorage)
      {
        return this.$t('info.availableSpaceInfo', { available: filesize(this.accountInfo.ustorage), total: filesize(this.accountInfo.tstorage)});
      }

      return this.$t('info.exhausted', { available: filesize(this.accountInfo.tstorage), total: filesize(this.accountInfo.tstorage)});
    },
    spaceBarStyles() {
      if (this.accountInfo.tstorage > this.accountInfo.ustorage) {
        return {width: this.accountUsage, backgroundColor: 'white'};
      } else {
        return {width: this.accountUsage, backgroundColor: 'red'};
      }
    },
  },
  async mounted () {
    if (this.isLogged) {
      try {
        this.isReseller = this.accountInfo.isreseller;
      } catch (e) {
        this.$showError(e);
      }

      await this.updateAccountInfo();
      this.fetchData();
    }
    window.addEventListener('click', this.mouseClick);
  },
  methods: {
    ...mapActions(['updateAccountInfo']),
    async fetchData() {
      if (this.isLogged) {
        this.getOpenSecrets();
      }

      if (!this.isCloudRoute) {
        this.isCloudClick = false;
        this.isCloud = false;
      }

      if (this.$route.name !== ROUTES.BACKUP) {
        this.isBackupClick = false;
        this.isBackup = false;
      }

      if (this.$route.name !== 'Reg') {
        this.isInboxClick = false;
        this.isInbox = false;
      }

      if (this.$route.name !== ROUTES.DOWNLOADS || this.$route.name !== ROUTES.UPLOADS) {
        this.isTransferClick = false;
        this.isTransfer = false;
      }

      if (this.$route.name !== 'Referrals' || this.$route.name !== 'Resellers') {
        this.isDealersClick = false;
        this.isDealers = false;
      }

      if (this.$route.name !== ROUTES.MY_SHARED_DRIVES || this.$route.name !== ROUTES.SHARED_WITH_ME) {
        this.isSharedDriveClick = false;
        this.isSharedDrive = false;
      }
      
      if (this.$route.name !== 'Profile Settings' && this.$route.name !== 'Invoicing Settings' && this.$route.name !== 'Invoicing Plans') {
        this.isConfigClick = false;
        this.isConfig = false;
      }
    },
    mouseClick() {
      if (this.isBackup && !this.isBackupClick) {
        this.isInbox = false;
        this.isCloud = false;
        this.isTransfer = false;
        this.isDealers = false;
        this.isConfig = false;
        this.isLogout = false;
        this.isSharedDrive = false;
        this.isBackupClick = true;
        this.isInboxClick = false;
        this.isCloudClick = false;
        this.isTransferClick = false;
        this.isDealersClick = false;
        this.isConfigClick = false;
        this.isLogoutClick = false;
        this.isSharedDriveClick = false;
      } if (this.isSharedDrive && !this.isSharedDriveClick) {
        this.isInbox = false;
        this.isCloud = false;
        this.isTransfer = false;
        this.isDealers = false;
        this.isConfig = false;
        this.isLogout = false;
        this.isBackup = false;
        this.isInboxClick = false;
        this.isCloudClick = false;
        this.isTransferClick = false;
        this.isDealersClick = false;
        this.isConfigClick = false;
        this.isLogoutClick = false;
        this.isSharedDriveClick = true;
      } else if (this.isInbox && !this.isInboxClick) {
        this.isBackup = false;
        this.isCloud = false;
        this.isTransfer = false;
        this.isDealers = false;
        this.isConfig = false;
        this.isLogout = false;
        this.isSharedDrive = false;
        this.isBackupClick = false;
        this.isCloudClick = false;
        this.isTransferClick = false;
        this.isDealersClick = false;
        this.isConfigClick = false;
        this.isLogoutClick = false;
        this.isSharedDriveClick = false;
      } else if (this.isCloud && !this.isCloudClick) {
        this.isInbox = false;
        this.isBackup = false;
        this.isTransfer = false;
        this.isDealers = false;
        this.isConfig = false;
        this.isLogout = false;
        this.isSharedDrive = false;
        this.isBackupClick = false;
        this.isInboxClick = false;
        this.isCloudClick = true;
        this.isTransferClick = false;
        this.isDealersClick = false;
        this.isConfigClick = false;
        this.isLogoutClick = false;
        this.isSharedDriveClick = false;
      } else if (this.isTransfer && !this.isTransferClick) {
        this.isInbox = false;
        this.isCloud = false;
        this.isBackup = false;
        this.isDealers = false;
        this.isConfig = false;
        this.isLogout = false;
        this.isSharedDrive = false;
        this.isBackupClick = false;
        this.isInboxClick = false;
        this.isCloudClick = false;
        this.isTransferClick = true;
        this.isDealersClick = false;
        this.isConfigClick = false;
        this.isLogoutClick = false;
        this.isSharedDriveClick = false;
      } else if (this.isDealers && !this.isDealersClick) {
        this.isInbox = false;
        this.isCloud = false;
        this.isBackup = false;
        this.isTransfer = false;
        this.isConfig = false;
        this.isLogout = false;
        this.isSharedDrive = false;
        this.isBackupClick = false;
        this.isInboxClick = false;
        this.isCloudClick = false;
        this.isTransferClick = false;
        this.isDealersClick = true;
        this.isConfigClick = false;
        this.isLogoutClick = false;
        this.isSharedDriveClick = false;
      } else if (this.isConfig && !this.isConfigClick) {
        this.isInbox = false;
        this.isCloud = false;
        this.isTransfer = false;
        this.isDealers = false;
        this.isBackup = false;
        this.isLogout = false;
        this.isSharedDrive = false;
        this.isBackupClick = false;
        this.isInboxClick = false;
        this.isCloudClick = false;
        this.isTransferClick = false;
        this.isDealersClick = false;
        this.isConfigClick = true;
        this.isLogoutClick = false;
        this.isSharedDriveClick = false;
      } else if (this.isLogout && !this.isLogoutClick) {
        this.isInbox = false;
        this.isCloud = false;
        this.isTransfer = false;
        this.isDealers = false;
        this.isConfig = false;
        this.isBackup = false;
        this.isSharedDrive = false;
        this.isBackupClick = false;
        this.isInboxClick = false;
        this.isCloudClick = false;
        this.isTransferClick = false;
        this.isDealersClick = false;
        this.isConfigClick = false;
        this.isLogoutClick = true;
        this.isSharedDriveClick = false;
      }
    },
    mouseEnterBackup() {
      this.isBackup = true;
    },
    mouseLeaveBackup() {
      if (!this.isBackupClick) {
        this.isBackup = false;
      }
    },
    mouseEnterSharedDrive() {
      this.isSharedDrive = true;
    },
    mouseLeaveSharedDrive() {
      if (!this.isSharedDriveClick) {
        this.isSharedDrive = false;
      }
    },
    mouseEnterInbox() {
      this.isInbox = true;
    },
    mouseLeaveInbox() {
      if (!this.isInboxClick) {
        this.isInbox = false;
      }
    },
    mouseEnterCloud() {
      this.isCloud = true;
    },
    mouseLeaveCloud() {
      if (!this.isCloudClick) {
        this.isCloud = false;
      }
    },
    mouseEnterTransfer() {
      this.isTransfer = true;
    },
    mouseLeaveTransfer() {
      if (!this.isTransferClick) {
        this.isTransfer = false;
      }
    },
    mouseEnterDealers() {
      this.isDealers = true;
    },
    mouseLeaveDealers() {
      if (!this.isDealersClick) {
        this.isDealers = false;
      }
    },
    mouseEnterConfig() {
      this.isConfig = true;
    },
    mouseLeaveConfig() {
      if (!this.isConfigClick) {
        this.isConfig = false;
      }
    },
    mouseEnterLogout() {
      this.isLogout = true;
    },
    mouseLeaveLogout() {
      this.isLogout = false;
    },
    mouseEnterLogin() {
      this.isLogin = true;
    },
    mouseLeaveLogin() {
      this.isLogin = false;
    },
    mouseEnterSignup() {
      this.isSignup = true;
    },
    mouseLeaveSignup() {
      this.isSignup = false;
    },
    help () {
      this.$store.commit('showHover', 'help');
    },
    show() {
      this.isRotate = !this.isRotate;
    },
    async getOpenSecrets() {
      try {
        this.openSecrets = await ibbapi.getOpenSecrets();
      } catch (e) {
        this.$showError(e);
      }
    },
    logout() {
      this.$store.commit('showHover', CheckPassword.name);
      // return auth.logout();
    },
  }
};
</script>
